import { createSlice } from '@reduxjs/toolkit'
import Cookies from "js-cookie";

const initialState = {
    // eslint-disable-next-line
    isLoggedIn: Cookies.get(process.env.REACT_APP_FREELANCER_TOK),
    activeAccount: false
}

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setActiveAccount: (state, action) => {
            state.activeAccount = action.payload
        },
        login: (state) => {
            state.isLoggedIn = true
        },
        logout: (state) => {
            state.isLoggedIn = false
        },
    },
})


export const { login, logout, setActiveAccount } = userSlice.actions

export default userSlice.reducer
